import SectionCard from '@/components/LocationPrint/SectionCard';
import ReceiptLayout from '@/components/Receipt/ReceiptLayout';

import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import {
  LOCATION_PRINT_CRUISE,
  LOCATION_PRINT_DETAIL_CRUISE,
} from '@repo/constants';
import { useState } from 'react';
import styled from 'styled-components';

const LocationPrintCruise = () => {
  const { nationality, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const [selectLocation, setSelectLocation] = useState<any>('IncheonIntl');

  return (
    <ReceiptLayout>
      <Title>
        {nationality === 'KOR' ? '프린트기 위치' : 'Printer Location'}
      </Title>
      <BadgeWrapper>
        {LOCATION_PRINT_CRUISE.map(({ key, name, nameKor }) => (
          <li key={key}>
            <Badge
              type='button'
              onClick={() => setSelectLocation(key)}
              isSelected={key === selectLocation}
            >
              {nationality === 'KOR' ? nameKor : name}
            </Badge>
          </li>
        ))}
      </BadgeWrapper>
      <LocationWrapper>
        {/* @ts-ignore */}
        {LOCATION_PRINT_DETAIL_CRUISE[selectLocation].length > 0 ? (
          // @ts-ignore
          LOCATION_PRINT_DETAIL_CRUISE[selectLocation].map(
            (printData: any, index: number) => {
              return (
                <li key={index}>
                  <SectionCard
                    type={printData.type}
                    location={printData.location}
                    time={printData.time}
                    tel={printData.tel}
                    imgSrc={printData.img}
                    mapSrc={printData.map}
                    viewMap={printData.viewMap}
                  />
                </li>
              );
            },
          )
        ) : (
          <Empty>Information Not Found</Empty>
        )}
      </LocationWrapper>
    </ReceiptLayout>
  );
};

export default LocationPrintCruise;

const Title = styled.strong`
  display: block;
  width: 100%;
  margin-top: 20px;
  color: #3a3b3e;
  text-align: left;
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
`;

const BadgeWrapper = styled.ul`
  display: flex;
  gap: 6px;
  width: 100%;
  margin: 16px auto 20px;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Badge = styled.button<{ isSelected: boolean }>`
  padding: 6px 16px;
  border-radius: 6px;
  background: ${({ isSelected }) => (isSelected ? '#3a3b3e' : '#F5F6F7')};
  color: ${({ isSelected }) => (isSelected ? '#fff' : '#A7A7A7')};
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
  white-space: nowrap;
`;

const LocationWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0px 0 100px;
  list-style: none;
`;

const Empty = styled.div`
  border-radius: 8px;
  border: 1px solid var(--KTP-Color-Mono-10, #e5e6e8);
  background: var(--KTP-Color-Mono-05, #f5f6f7);
  width: 100%;
  padding: 24px;
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  font-size: 16px;
  font-weight: 600;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
  text-align: center;
`;
